RivalIQ.apps.Dashboard.module('widgets.table', function (table, App, Backbone, Marionette, $, _) {

    'use strict';

    const metricTypes = RivalIQ.enums.metricType;

    function getSortOrderClass(sortOrder) {
        return (sortOrder === -1 ? 'sort-asc' : 'sort-desc');
    }

    const HeaderCellPrototype = {
        getMetric: function (index) {
            const me = this;
            return me.collection.at(me.invert ? 0 : index);
        },
        getDefaultClassName: function (metric, index) {
            const metricType = metric.getMetricType();
            if (index === 0 || metricType === metricTypes.STRING || metricType === metricTypes.TEXT) {
                return 'string-metric-header-cell';
            }

            return 'metric-header-cell';
        },
        className: function (index) {
            const me = this;

            const metric = me.getMetric(index);
            const classes = [
                // Auto generated class, use this if you can!
                `measure-${metric.get('property').replace(/\.|_/, '-')}`,
                // for context specific overriding
                _.get(metric, 'attributes.header.className'),
                me.getDefaultClassName(metric, index)
            ];

            if (me.isSortable(index)) {
                classes.push('x-sort pointer');
            }

            if (me.sortedBy === index) {
                classes.push('sort-active');
            }

            return classes.join(' ');
        },
        isSortable: function (index) {
            const me = this;
            if (!me.sortable) {
                return false;
            }
            const metric = me.getMetric(index);
            return metric.get('sortable') !== false;
        },
        getSortClass: function (index) {
            const me = this;
            if (me.sortedBy === index) {
                return getSortOrderClass(me.sortOrder);
            }
        },
        getSortOrder: function (index) {
            const me = this;
            if (me.isSortable(index) && me.sortedBy === index) {
                return me.sortOrder;
            }
        },
        serializeData: function (column, index) {
            const me = this;

            return _.extend({
                index: index,
                sortOrder: me.getSortOrder(index),
                className: me.className(index),
                sortClass: me.getSortClass(index),
                description: column.description || '',
                abbreviatedName: column.abbreviatedName || '',
                fontIcon: column.fontIcon,
                channelSvg: column.channelSvg,
                aggregate: null
            }, column);
        },

        render: function (column, index) {
            const me = this;
            return Marionette.TemplateCache.get('#metricTableHeaderCell')(me.serializeData(column, index));
        }
    };

    table.HeaderCell = function (attrs) {
        const me = this;
        _.extend(me, attrs);
    };

    table.HeaderCell.renderText = function (node, column, dontAbbreviateHeaders) {
        const content = $(node).find('.ellipse-content');

        // note: on firefox, the innertext is a string of spaces, so we have to trim here.
        const innerText = _.get(content, 'context.innerText', '').trim();
        if (!innerText) {

            let name = column.name;
            if (!dontAbbreviateHeaders) {
                // abbreviate the name if an abbreviation hasn't been given already
                name = RivalIQ.utils.text.abbreviate(name);
            }

            content.text(name);
        }
    };

    table.HeaderCell.initializePopovers = function (node) {
        $(node).popover({
            trigger: 'hover',
            container: 'body',
            placement: 'auto'
        });
    };

    table.HeaderCell.prototype = HeaderCellPrototype;
});
